import { IDS_URL } from "appConfiguration";

const PARAM_KEYS = {
  userId: "UserId",
  clientId: "ClientId",
  redirectUri: "RedirectUri",
} as const;

export function impersonateUser(userId: string) {
  const url = new URL("/Account/ImpersonateExternal", IDS_URL);
  url.searchParams.set(PARAM_KEYS.userId, userId);
  url.searchParams.set(PARAM_KEYS.clientId, "Next_App");
  url.searchParams.set(
    PARAM_KEYS.redirectUri,
    `${window.location.origin}/impersonation-callback`
  );
  window.location.href = url.toString();
}

export function exitImpersonation() {
  const url = new URL("/Account/BackToImpersonatorExternal", IDS_URL);
  url.searchParams.set(PARAM_KEYS.clientId, "Next_App");
  url.searchParams.set(
    PARAM_KEYS.redirectUri,
    `${window.location.origin}/impersonation-callback`
  );
  window.location.href = url.toString();
}
